module.exports = __webpack_public_path__ + "img/file-download-laptop.13e46764.svg";